import React from "react";

import background from "@cover/klimakrisestoppen/background-1.jpg";
import backgroundSm from "@cover/klimakrisestoppen/background-1-sm.jpg";
import background2 from "@cover/klimakrisestoppen/background-2.png";
import background2Sm from "@cover/klimakrisestoppen/background-2-sm.png";
import background3 from "@cover/klimakrisestoppen/background-3.png";
import background3Sm from "@cover/klimakrisestoppen/background-3-sm.png";
import background4 from "@cover/klimakrisestoppen/background-4.png";
import background4Sm from "@cover/klimakrisestoppen/background-4-sm.png";
import KlimakriseStoppen from "../components/cover/animations/klimakrisestoppen";

import articleSrc from '@assets/article.svg';

export const meta = {
  category: "stop",
  slug: "klimakrise",
  id: "KlimakriseStoppen",
  name: "klimakrisestoppen",
  title: "Stadt, Land, Schluss?",
  excerpt: {
		before: "Bernhard Lenz ist Professor für nachhaltige Gebäudetechnologie und energieoptimiertes Entwerfen an der Hochschule Karlsruhe. Sein innovatives Forschungsprojekt BREEZE unterstützt die Baden-Württemberg Stiftung im Rahmen des Programms ",
		italic: "Klimaanpassung",
		after: "."
	},
  animation: KlimakriseStoppen,
  cover: {
    background: {
      lg: background,
      sm: backgroundSm,
    },
    layers: [
      {
        src: {
          lg: background2,
          sm: background2Sm,
        },
        zIndex: 333,
      },
      {
        src: {
          lg: background3,
          sm: background3Sm,
        },
        zIndex: 666,
      },
      {
        src: {
          lg: background4,
          sm: background4Sm,
        },
        zIndex: 999,
      },
    ],
    alt: "Bernhard Lenz, Initiator des Forschungsprojekts BREEZE, steht zwischen Hochhäusern, Meereswellen und Berggipfeln. Warme, feuchte Luft steigt auf einer Seite von ihm nach oben, um auf der anderen Seite als Regen auf die skizzierte Großstadt zu fallen.",
  },
};

const KlimakrisestoppenArticle = () => {
  return (
    <div>
      <p className="articleParagraph">
        Klimawandel und Innovationsstreben treiben den Forschergeist von
        Bernhard Lenz an. Der Professor für nachhaltige Gebäudetechnologie und
        energieoptimiertes Entwerfen an der Hochschule Karlsruhe will die hohen
        Niederschläge im Winter nutzen, um damit im Sommer die Städte
        abzukühlen. Und er will, dass die Menschen die möglichen Folgen des
        Klimawandels bereits heute hautnah erleben können. Die Baden-Württemberg
        Stiftung unterstützt das innovative Projekt im Rahmen ihres Programms
        <i> Klimaanpassung</i>.
      </p>
      <p className="articleQuestion">
        Sie haben Ihrem Forschungsprojekt den Titel BREEZE gegeben, was so viel
        wie Brise bedeutet. Was steckt dahinter?
      </p>
      <p className="articleAnswer">
        <i>Berhard Lenz:</i> Im Zuge des Klimawandels ist davon auszugehen, dass
        die sommerlichen Temperaturen steigen und wir mit länger anhaltenden
        Hitzeperioden rechnen müssen. Das heißt, in den Städten wird es teils
        deutlich wärmer werden und es wird weniger komfortabel sein, sich dort
        aufzuhalten. Im Winter wird sich ebenfalls einiges ändern: Vielerorts
        wird es häufiger regnen und das Überschwemmungsrisiko steigt. Dies
        wiederum bedeutet, dass uns im Sommer zu wenig und im Winter zu viel
        Wasser zur Verfügung stehen wird. Der Grundgedanke von BREEZE ist, nicht
        zwei Lösungen für die jeweiligen klimatischen Herausforderungen zu
        suchen, sondern beide Entwicklungen miteinander zu verknüpfen.
      </p>
      <p className="articleQuestion">Wie wollen Sie das tun?</p>
      <p className="articleAnswer">
        Indem wir das Mehr an Regenwasser im Winter in dezentralen Zisternen
        auffangen und es saisonal verzögert im Sommer über ein innovatives
        überirdisches Verdunstungssystem wieder abgeben. Kavernensysteme gibt es
        unter anderem in großen Städten wie München oder Tokio. Dort schützen
        sie beispielsweise die Metro. Das Niederschlagswasser wird dabei
        allerdings nur kurz zwischengespeichert und dann abgeleitet. Zur
        Verbesserung des Stadtklimas wird es hingegen nicht genutzt.
      </p>
      <p className="articleQuestion">
        Wie kann man sich das Verdunstungssystem vorstellen? Ist das ein
        Rohrsystem mit Düse, über das Wasserdampf an die Oberfläche gelangt?
      </p>
      <p className="articleAnswer">
        Nein, eher nicht. Das Verdunstungssystem wird zwar über Rohrleitungen
        mit dezentralen Speichern verbunden – es ist jedoch vielmehr eine
        flexibel integrierbare überirdische Teilkomponente eines Gesamtsystems.
        Zum Beispiel könnte es auf einem Platz eine muldenartige Sitzgelegenheit
        geben, in die BREEZE integriert ist und wo sich Menschen abkühlen. Es
        ist es aber auch möglich, BREEZE an eine bestehende Infrastruktur zu
        koppeln, beispielsweise bei Straßenlaternen. Man könnte das System so
        gestalten, dass es bestehende Laternenmasten ummantelt. Nachts versorgen
        die Laternen die Stadt mit Licht, tagsüber übernehmen sie die Kühlung
        des urbanen Raums.
      </p>
      <p className="articleQuestion">
        Und wenns im Sommer heiß wird, könnten sich Städterinnen und Städter
        unter die Laternen stellen und sich von kühlem Wasser besprühen lassen.
        Schöne Vorstellung!
      </p>
      <p className="articleAnswer">
        Nein, das geht leider nicht. Das Oberflächenabflusswasser ist nicht so
        sauber wie Trinkwasser. Es ist Regenwasser, das über Straßen und Plätze
        abgeführt und nicht aufwendig aufbereitet wird. Wenn das Wasser
        versprüht würde, liefen wir Gefahr, mögliche Keime über Wassertröpfen zu
        transportieren. Deshalb arbeiten wir mit dreidimensionalen
        Verdunstungsoberflächen. Der Vorteil unseres Systems ist auch, dass sich
        der oberirdische Teil je nach Bedarf auf- und abbauen lässt.
      </p>
      <p className="articleQuestion">Haben Sie ein Beispiel?</p>
      <p className="articleAnswer">
        Stellen Sie sich einen Platz vor, der bei einer Fußballmeisterschaft
        fürs Public Viewing genutzt wird. Viele Menschen kommen zusammen und
        möchten die Spiele genießen, ohne dass ihnen die Sicht versperrt wird.
        Bei einer solchen Veranstaltung würde unsere Teilkomponente also
        demontiert und später wieder angeschlossen. Ein weiterer Vorteil unseres
        Systems ist, dass es sich vorausschauend steuern lässt. Denn wir wissen,
        wie viel Wasser eingespeichert ist und wie sich die Wetterlage in den
        nächsten Tagen verändern wird. Auf Basis dieser Informationen kann viel
        Wasser zu Abkühlung genutzt werden, weil sich eine Regenfront ankündigt.
        Oder der Verbrauch wird reduziert, weil eine länger anhaltende
        Hitzewelle droht.
      </p>
      <p className="articleQuestion">
        Es geht Ihnen bei BREEZE nicht nur um die klimatische Verbesserung von
        Städten – Sie möchten Menschen mögliche Folgen des Klimawandels bereits
        heute näherbringen und zwar hautnah. Was haben Sie vor?
      </p>
      <p className="articleAnswer">
        Das ist ein ebenfalls sehr wichtiger Teil unseres Forschungsprojekts.
        Wir wollen nicht einfach eine Klimawandelanpassung umsetzen und den
        Menschen dadurch das Gefühl vermitteln, dass der fortschreitende
        Klimawandel kein Problem ist, weil wir technische Lösungen finden. Das
        führt aus meiner Sicht in die falsche Richtung. Bei BREEZE wird es
        deshalb ein interaktives Element geben. Bürgerinnen und Bürger werden
        auf einfache und attraktive Weise dazu animiert, mit dem System zu
        interagieren, um die Auswirkungen auf die Umwelt und auf sie persönlich
        unmittelbar zu erfahren.
      </p>
      <p className="articleQuestion">
        Wie kann ich mir das konkret vorstellen?
      </p>
      <p className="articleAnswer">
        Nehmen wir als Beispiel die Sitzmulde auf einem innerstädtischen Platz,
        über die wir eingangs gesprochen haben: An diesem Ort hätten Sie über
        ein Interface die Möglichkeit, die Temperatur in der Mulde einem
        Klimawandelszenario anzupassen. Sie können zum Beispiel unmittelbar
        erfahren, wie sich eine Temperaturerhöhung von drei Grad genau an diesem
        Standort auswirken würde, trotz einer Anpassung über BREEZE.
      </p>
      <p className="articleQuestion">
        Das Pariser Klimaabkommen möchte die globale Erderwärmung auf 1,5
        beziehungsweise maximal zwei Grad begrenzen. Wie kommen Sie auf drei
        Grad?
      </p>
      <p className="articleAnswer">
        Im Rahmen eines Forschungsstipendiums, das ich in Großbritannien
        absolvierte, zeigte sich, dass sich eine globale Temperaturerhöhung
        lokal viel stärker auswirkt. Bei zwei Grad plus weltweit ist in
        innerstädtischen Lagen ist mit einem Anstieg von etwa fünf Grad zu
        rechnen! Es mag ein bisschen emotional klingen, aber ich muss Ihnen
        sagen, dass man wirklich nicht mehr besonders gut schlafen kann, wenn
        man derartige Ergebnisse ermittelt.
      </p>
      <p className="articleQuestion">Warum?</p>
      <p className="articleAnswer">
        Es ist anscheinend immer noch viel zu wenigen Menschen klar, was durch
        den Klimawandel auf lokaler Ebene auf uns zukommt! Wir reden immer über
        globale Ereignisse. Ein Gletscher in Nepal schmilzt oder der
        Permafrostboden der arktischen Tundra taut auf. So schlimm wirds bei uns
        schon nicht werden. Aber das Gegenteil ist der Fall! Globale
        Veränderungen führen zu Veränderungen in der Stadt, in der man lebt.
      </p>
      <p className="articleQuestion">
        Ihr interaktiver Ansatz soll das Bewusstsein dafür schärfen?
      </p>
      <p className="articleAnswer">
        Genau. Es geht dabei um das unmittelbare Erleben von
        Temperaturunterschieden und nicht um abstrakte Zahlen. Ohne erhobenen
        Zeigefinger möchten wir im Sinne eines Serious Game spielerisch
        vermitteln, dass globale Veränderungen auch Konsequenzen vor der eigenen
        Haustür nach sich ziehen. Kurzum, ich möchte mit diesem Projekt nicht
        nur einen innovativen und zukunftsweisenden Beitrag zur Anpassung an den
        Klimawandel leisten, sondern hoffe auch zu einem Umdenken in unserer
        Gesellschaft beitragen zu können.
      </p>
      <a
        href="https://www.bwstiftung.de/de/programm/klimaanpassung"
        target="_blank"
        className="articleLink articleLink--block"
      >
        <div className="articleLinkIcon">
          <img src={articleSrc} />
        </div>
        <div>
          Klimaanpassung - Baden-Württemberg Stiftung
          <div className="articleLinkSource">bwstiftung.de</div>
        </div>
      </a>
    </div>
  );
};

export default KlimakrisestoppenArticle;
